module.exports = __webpack_public_path__ + "img/voron-registry-logo.7790a371.svg";